import superMeta from '../_ABSTRACT/metaAbstractNode.mjs'

export default {
    ...superMeta,
    name: '界面能力',
    type: 'UE_',
}
